import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "enter--sprite",
  "use": "enter--sprite-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"enter--sprite\">\n<path d=\"M40.5 36V37H41.5V36H40.5ZM21.2929 35.2929C20.9024 35.6834 20.9024 36.3166 21.2929 36.7071L27.6569 43.0711C28.0474 43.4616 28.6805 43.4616 29.0711 43.0711C29.4616 42.6805 29.4616 42.0474 29.0711 41.6569L23.4142 36L29.0711 30.3431C29.4616 29.9526 29.4616 29.3195 29.0711 28.9289C28.6805 28.5384 28.0474 28.5384 27.6569 28.9289L21.2929 35.2929ZM39.5 19V36H41.5V19H39.5ZM40.5 35H22V37H40.5V35Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol